import { Children, ReactElement, ReactNode, cloneElement, isValidElement, useEffect, useState } from 'react'
import { Renderable } from '../classes/renderer'

export function useLayers(children: ReactNode) {
    const [refs, setRefs] = useState<Renderable[]>([])
    const [nodes, setNodes] = useState<ReactNode[]>([])

    useEffect(() => {
        const layerRefs: Renderable[] = []
        const childNodes = Children.map(children, (child, i) => {
            if (isValidElement(child)) {
                return cloneElement(child as ReactElement<any>, {
                    ref: (childRef: any) => {
                        if (childRef && childRef.draw) {
                            layerRefs[i] = childRef
                        }
                    },
                })
            }
            return child
        })

        setRefs(layerRefs)
        setNodes(childNodes || [])
    }, [children])

    return { nodes, refs }
}
